import React, { Component } from 'react'
import next from '../../assets/images/newui/sellersignup/next-btn.svg'
import tick from '../../assets/images/newui/sellersignup/tick-white.svg'
import './InvoiceSection.less'
import { getDiscount } from 'services/Seller'
import FeatureListItemUpdated from './FeatureListItemUpdated'
import { Icon } from 'semantic-ui-react'

class InvoiceSection extends Component {
    constructor(props) {
        super(props)
        this.state = {
            promo: '',
            invalidPromo: false,
            discount: null,
            isPromoVisible: false
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.activeTabIndex !== this.props.activeTabIndex && this.props.activeTabIndex == 2) {
            this.verifyPromo();
        }
    }

    getPlanImage = () => {
        return require(`../../assets/images/newui/sellersignup/${this.props.planType}.svg`).default;
    }

    verifyPromo = async (e) => {
        if (e) e.preventDefault();
        if (!this.state.promo) return;
        const discountRes = await getDiscount(this.state.promo, this.props.isSellerLoggedIn);
        if (discountRes.resStatus == 200) {
            this.setState({ invalidPromo: false, discount: discountRes.data })
            this.props.onChange({ promo: this.state.promo })
        } else {
            this.setState({ invalidPromo: true, discount: null })
            this.props.onChange({ promo: null })
        }
    }

    getInvoiceTotal = () => {
        const { discount } = this.state;
        const discountAmount = discount ? discount.amount || discount.percentage * this.props.planPrice / 100 : 0;
        return Math.ceil(this.props.planPrice - discountAmount);
    }

    removeDiscount = (e) => {
        e.preventDefault();
        this.setState({ discount: null, promo: '' });
    }

    render() {
        const categoryImage = this.props.selectedCategory.detailImageNarrow ? this.props.selectedCategory.detailImageNarrow.URL : '';
        return <div className='invoice-section-container'>
            {this.props.isTopHidden ? "" : <div className='invoice-section-top'>
                <div className='invoice-section-badge'>
                    <img src={tick} />
                    <div className='invoice-section-badge-content'>Selected Plan</div>
                </div>
                {this.props.planType == 'premium' ? <div className='invoice-section-img'>
                    <img src='https://com-syndafy-dealgrace-static.s3.us-east-2.amazonaws.com/most-pop_1gmhgfwwkrkwyj0d_.png' />
                </div> : ''}
                <div className='plan-details-container' >
                    <img className='plan-img' src={this.getPlanImage()}></img>
                    <div className='plan-details'>
                        <div className={`plan-name ${this.props.planType}`}>{this.props.planName}</div>
                        {/*<div className="plan-price">${Number(this.props.planPrice)} <span>/month</span></div>*/}
                        <div className="plan-price">{!this.props.isTrialPlan && <><span>${Number(this.props.planPrice)}</span> <span>/month</span></>}</div>
                    </div>
                </div>
                <div><b>{!this.props.isTrialPlan && `+`} {`${this.props.commission ? this.props.commission + '% Commission' : '$' + Number(this.props.referralFee) + ' Referral'} Fee `}</b>
                    {this.props.selectedCategory.referralText}</div>
                <div className='feature-list-item-container'>
                    {this.props.features && this.props.features.length > 0 && this.props.features.map(f => <FeatureListItemUpdated content={f.featureName} />)}
                </div>
            </div>}
            {this.props.isBottomHidden ? "" : <div className='invoice-section-bottom'>
                <div className={`invoice-section-category${this.props.isTopHidden ? ' without-border' : ''} `}>
                    <div className='invoice-section-category-name'>
                        {this.props.selectedCategory.name}
                    </div>
                    {categoryImage != '' ? <div className='invoice-section-category-img'>
                        <img className='invoice-header-category-img' src={categoryImage} />
                    </div> : ''}
                </div>
                {!this.props.isCommissionOnly ? <div className='promo-container'>
                    <div className='promo-heading'>Promo Code
                        <Icon onClick={() => this.setState({ isPromoVisible: !this.state.isPromoVisible })} name={`chevron ${this.state.isPromoVisible ? 'up' : 'down'}`} />
                    </div>
                    {this.state.isPromoVisible ? <div className='promo-input-container'>
                        {this.state.discount ?
                            <>
                                <div className='promo-details'>
                                    <div className='promo-code'>{this.state.promo}</div>
                                    <div className='promo-short-desc'>{this.state.discount.shortDesc}</div>
                                </div>
                                <button className='promo-submit remove' onClick={this.removeDiscount} >Remove&nbsp;&#10005;</button></>
                            : <>
                                <input type='text' value={this.state.promo} onChange={(e) => this.setState({ promo: e.target.value })} placeholder='Enter promo code' className={`promo-input${this.state.invalidPromo ? ' error' : ''}${this.state.discount ? ' promo-applied' : ''}`} />
                                <button className='promo-submit' onClick={this.verifyPromo}> Apply</button> </>}
                        {this.state.invalidPromo ? <div className='promo-input-error'>Invalid Promo code</div> : ''}
                    </div> : ''}
                </div> : ''}

                <div className='plan-total'>
                    {/* {this.props.isTrialPlan ? <div className='plan-total-trial'>
                        After Trial Completion
                        <span class="usd-text">USD</span>
                        {Number(this.props.planPrice) != this.getInvoiceTotal() ? <span class="trial-plan-price">${Number(this.props.planPrice)}</span> : ''}
                        <span class="trial-invoice-total">${this.getInvoiceTotal()} </span>
                    </div> : ''} */}
                    <div className='plan-total-heading'>Due Today</div>
                    <div className='plan-total-price'>
                        {this.state.discount && !this.props.isTrialPlan ? <div className='plan-old-price'>${Number(this.props.planPrice)}</div> : ''}
                        <span>USD</span>${this.props.isTrialPlan ? '0' : this.getInvoiceTotal()}</div>
                </div>
                <button className='invoice-submit-btn' type='submit'>{this.props.isTrialPlan ? 'Start Trial ' : 'GO '}<img src={next} /></button>
            </div>}
        </div>
    }
}

export default InvoiceSection;